//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from '@/utils/i18n';
export default {
  name: 'type-editor',
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  computed: {},
  methods: {
    changeType: function changeType(val) {
      if (val === 'text') {
        this.optionModel.showPassword = false;
      }
    }
  }
};